export default {
  path: 'collect',
  meta: {
    title: '集采管理'
  },
  name: 'collect',
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'audit',
      meta: {
        title: '需求单审核'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '需求单审核',
            ignoreBreadCrumb: true
          },
          name: 'self-collect-audit',
          component: () => import('@/view/v5/collect/audit.vue')
        },
        {
          path: ':id',
          meta: {
            hideInTabBar: true,
            title: '需求单详情'
          },
          name: 'collect-audit-detail',
          component: () => import('@/view/v5/collect/detail.vue')
        }
      ]
    },
    {
      path: 'set',
      meta: {
        title: '业务设置'
      },
      name: 'self-collect-bus-set',
      component: () => import('@/view/v5/collect/bus-set/index.vue')
    },
    {
      path: 'info',
      meta: {
        title: '集采信息'
      },
      name: 'self-collect-info',
      component: () => import('@/view/v5/collect/info.vue')
    },
    {
      path: 'activity',
      meta: {
        title: '活动管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '活动管理',
            ignoreBreadCrumb: true,
            notCache: false
          },
          name: 'self-collect-activity-list',
          component: () => import('@/view/v5/collect/activity/list.vue')
        },
        {
          path: 'add',
          meta: {
            title: '新增集采活动'
          },
          name: 'self-collect-activity-add',
          component: () => import('@/view/v5/collect/activity/edit.vue')
        },
        {
          path: 'edit',
          meta: {
            title: '编辑集采活动'
          },
          name: 'self-collect-activity-edit',
          component: () => import('@/view/v5/collect/activity/edit.vue')
        },
        {
          path: 'detail',
          meta: {
            title: '活动详情'
          },
          name: 'self-collect-activity-detail',
          component: () => import('@/view/v5/collect/activity/detail.vue')
        }
      ]
    },
    {
      path: 'manage',
      name: 'self-collect-manage',
      meta: {
        title: '需求单管理'
      },
      component: () => import('@/view/v5/collect/manage.vue')
    },
    {
      path: 'statistics',
      name: 'self-collect-statistics',
      meta: {
        title: '需求单统计',
        keepAlive: true
      },
      component: () => import('@/view/v5/collect/statistics.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/collect.js